export const enum CollectionViewType {
  CREATE = 'create',
  EDIT = 'edit',
  LIST = 'list',
  DETAIL = 'detail',
}
